import { Link } from "react-router-dom";

export const ActionSelectOption = ({ children, icon: Icon, onSelect, to, href }) => {
  const content = <>{Icon && <Icon aria-hidden="true" />}{children}</>;
  const className = "action-select-option";

  if (to) return <Link className={className} to={to} onClick={onSelect}>{content}</Link>;
  if (href) return <a className={className} href={href} onClick={onSelect}>{content}</a>;
  return <button className={className} type="button" onClick={onSelect}>{content}</button>;
};
